import type { MantineColor, StyleProp } from '@mantine/core'
import { Paper, Text } from '@mantine/core'
import classes from './OrderMetaInfoCheck.module.css'

interface OrderMetaInfoCheckProps {
  items: string[]
  bg?: StyleProp<MantineColor>
  size?: 'sm' | 'md' | 'lg'
}

export function OrderMetaInfoCheck({
  items,
  bg,
  size = 'md',
}: OrderMetaInfoCheckProps) {
  if (!items.length) {
    return null
  }

  const sizeClass
    = size === 'sm' ? classes.sizeSm : size === 'lg' ? classes.sizeLg : classes.sizeMd

  return (
    <Paper bg={bg} className={`${classes.infoCard} ${sizeClass}`}>
      <Text span className={classes.checkLabel}>Check</Text>
      <div className={classes.emojiItemsList}>
        {items.map((item: string) => (
          <Text span className={classes.emojiItem} key={item}>{item}</Text>
        ))}
      </div>
    </Paper>
  )
}
